import { Tarifbereich } from '@ps20/bff-models';

export function getTarifbereich(
  versicherungsnehmer: { isAssekuranztarif: boolean; tarifbereich?: Tarifbereich },
  beziehungVpZumVn?: BeziehungZumVn,
): Tarifbereich {
  if (beziehungVpZumVn && beziehungVpZumVn === BeziehungZumVn.SONSTIGE) {
    return Tarifbereich.E;
  }

  if (versicherungsnehmer.tarifbereich && versicherungsnehmer.tarifbereich !== Tarifbereich.E) {
    return versicherungsnehmer.tarifbereich;
  }

  return versicherungsnehmer.isAssekuranztarif ? Tarifbereich.A : Tarifbereich.E;
}

export function determineAssekuranztarifFromTarifbereich(tarifbereich: Tarifbereich): boolean {
  return [Tarifbereich.A, Tarifbereich.FI].includes(tarifbereich);
}

export enum BeziehungZumVn {
  EHE_LEBENSPARTNER = 'L',
  KIND = 'K',
  SONSTIGE = 'S',
}
